import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from 'src/app/_services/loader.service';
import { Globals } from 'src/shared/globals';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToasterService } from 'src/app/_services/toaster.service';
import { EventEmitterService } from 'src/global_services/event-emitter.service';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.css'],
    standalone: false
})
export class ConfirmationComponent implements OnInit {

  key: string;
  constructor(private httpService: HttpClient,
              private route: ActivatedRoute,
              private loaderService: LoaderService,
              private global: Globals,
              private router: Router,
              private eventEmitterService: EventEmitterService,
              private toastr: ToasterService) {
    this.route.queryParams.subscribe(params => {
      this.key = params.key;
    });
  }

  ngOnInit() {
    this.loaderService.showLoader();
    this.confirmUserEmail().subscribe(result => {
      if (result.IsSuccess) {
        this.toastr.Success('Congratulations!', result.Message);
        localStorage.setItem('currentUser', JSON.stringify(result.Data));
        this.HeaderComponentReInitiateFunction();
        this.router.navigate(['/account/profile']);
      } else {
        this.toastr.Error(result.Message);
      }
      this.loaderService.hideLoader();
  });
  }

  confirmUserEmail(): Observable<any>  {
    let apiUrlConfirmUserEmail = this.global.apiUrl;
    apiUrlConfirmUserEmail += 'account/confirm/email?key=' + this.key;
    return this.httpService.get(apiUrlConfirmUserEmail);
  }

  HeaderComponentReInitiateFunction() {
    this.eventEmitterService.ComponentManipulator();
  }

}
